// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"ute-breadcrumb_breadcrumbs__CEsIe","eachLevel":"ute-breadcrumb_eachLevel__3jgf4","lastLevel":"ute-breadcrumb_lastLevel__CjSJQ"};